import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import LoginPage from './auth/LoginPage';
import AuthGate from './auth/AuthGate';
import { PosProfileProvider } from './pos/PosProfileContext';
import PosProfileSelect from './pos/PosProfileSelect';
import PosShell from './pos/PosShell';
import PosScreen from './pos/PosScreen';

/**
 * Root application component.
 *
 * Routes:
 *   /auth-login  — public login page
 *   /            — POS Profile selection (protected)
 *   /pos         — POS sales screen (protected)
 */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public route — no auth required */}
        <Route path="/auth-login" element={<LoginPage />} />

        {/* Protected routes — wrapped in AuthGate */}
        <Route
          path="/*"
          element={
            <AuthGate>
              <PosProfileProvider>
                <Routes>
                  <Route path="/" element={<PosProfileSelect />} />
                  <Route path="/pos" element={<PosShell />}>
                    <Route index element={<PosScreen />} />
                  </Route>
                </Routes>
              </PosProfileProvider>
            </AuthGate>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
